// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://eoezagrzonwesvepujpf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVvZXphZ3J6b253ZXN2ZXB1anBmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYyNzI0ODIsImV4cCI6MjA2MTg0ODQ4Mn0.EipP9HNljD0M6E41gCXCil1ZCr3XCEpkpFmiplJ2G7I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
